require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tmoignages-dtudiants-2-0-6.json") })
        }
      }, "path---tmoignages-dtudiants-2-0-6");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tmoignages-dtudiants-2-0-6!./.cache/json/tmoignages-dtudiants-2-0-6.json
// module id = 589
// module chunks = 231608221292675